module.exports = __webpack_public_path__ + "img/logo1.7e9b9760.png";